var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarningTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2662 6.27631C24.0352 4.9389 25.9648 4.9389 26.7338 6.27631L48.2768 43.7423C49.0434 45.0756 48.081 46.7393 46.5429 46.7393H3.45705C1.91902 46.7393 0.956577 45.0756 1.72324 43.7423L23.2662 6.27631Z",
    fill: "#E41830"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3536 39.6143C25.2598 39.7081 25.1326 39.7607 25 39.7607C24.8674 39.7607 24.7402 39.7081 24.6464 39.6143C24.5527 39.5205 24.5 39.3934 24.5 39.2607C24.5 39.1281 24.5527 39.001 24.6464 38.9072C24.7402 38.8134 24.8674 38.7607 25 38.7607C25.1326 38.7607 25.2598 38.8134 25.3536 38.9072C25.4473 39.001 25.5 39.1281 25.5 39.2607C25.5 39.3934 25.4473 39.5205 25.3536 39.6143Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 20.6521L25 34.7825L25 20.6521Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 20.6521L25 34.7825",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/warning-triangle.e6e45c760dd20a80e9b6513c54205c12.svg";
export { ForwardRef as ReactComponent };